import { typedQueryClient, useTypedMutation } from "hooks";
import { updateQuestionResultPinHistory } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/utils";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeletePinPayload } from "modules/AppointmentDetails/components/Interventions/hooks";

export const useDeleteQuestionResultPinMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeletePinPayload) => {
      await ApiInstance.post("/pins/delete", payload);
    },
    onSuccess: ({ question_result_id }) => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks?.length || !question_result_id) return;

      updateQuestionResultPinHistory({ checks, question_result_id, updatePinHistory: () => [] });
    }
  });
